<template>
    <div class="vip-benefit-list">
        <el-table :data="benefitList" border style="width: 100%" v-loading="loading">
            <el-table-column prop="id" label="ID" width="180"></el-table-column>
            <el-table-column prop="vipNo" label="会员卡号" width="150"></el-table-column>
            <el-table-column prop="item" label="运费券" min-width="120"></el-table-column>
            <el-table-column prop="benefitDate" label="开始日期" width="160"></el-table-column>
            <el-table-column prop="expireTime" label="过期时间" width="160"></el-table-column>
            <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                    <span>{{ formatStatus(scope.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="claimTime" label="领取时间" width="160"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <el-button
                            v-if="isEditableStatus(scope.row.status)"
                            size="mini"
                            type="primary"
                            :loading="scope.row.loading"
                            @click="handleReissue(scope.row)">
                        补发
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container" style="margin-top: 15px; text-align: right;">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageForm.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageForm.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "customerVipBenefit",
        props: {
            customerId: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                loading: false,
                benefitList: [],
                total: 0,
                pageForm: {
                    currentPage: 1,
                    pageSize: 10,
                    customerId: ''
                }
            };
        },
        watch: {
            customerId: {
                handler(val) {
                    if (val) {
                        this.pageForm.customerId = val;
                        this.getBenefitList();
                    }
                },
                immediate: true
            }
        },
        methods: {
            normalizeBenefitRow(row) {
                return {
                    id: row.id ?? row.ID,
                    vipNo: row.vipNo ?? row.VIP_NO,
                    item: row.item ?? row.ITEM,
                    benefitDate: row.benefitDate ?? row.BENEFIT_DATE,
                    expireTime: row.expireTime ?? row.EXPIRE_TIME,
                    status: row.status ?? row.STATUS,
                    claimTime: row.claimTime ?? row.CLAIM_TIME,
                    createTime: row.createTime ?? row.CREATE_TIME,
                    loading: false
                };
            },
            formatStatus(status) {
                if (!status) return '';
                const statusMap = {
                    UNCLAIMED: '未领取',
                    CLAIMED: '已领取',
                    EXPIRED: '已过期',
                    未领取: '未领取',
                    已领取: '已领取',
                    已过期: '已过期'
                };
                return statusMap[status] || status;
            },
            isEditableStatus(status) {
                return status === 'UNCLAIMED' || status === 'EXPIRED' || status === '未领取' || status === '已过期';
            },
            getBenefitList() {
                if (!this.pageForm.customerId) return;
                this.loading = true;
                this.$apiGet('lechun-cms/vip/getBenefitList', this.pageForm).then(res => {
                    this.loading = false;
                    if (res && res.list) {
                        this.benefitList = res.list.map((item) => this.normalizeBenefitRow(item));
                        this.total = res.total;
                    } else {
                        this.benefitList = [];
                        this.total = 0;
                    }
                }).catch(err => {
                    this.loading = false;
                });
            },
            handleSizeChange(val) {
                this.pageForm.pageSize = val;
                this.getBenefitList();
            },
            handleCurrentChange(val) {
                this.pageForm.currentPage = val;
                this.getBenefitList();
            },
            handleReissue(row) {
                this.$confirm('确认要执行补发操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$set(row, 'loading', true);
                    this.$apiGet('lechun-cms/vip/reissue', { id: row.id }).then(res => {
                        this.$message.success('补发成功');
                        this.getBenefitList();
                    }).catch(() => {
                         this.$set(row, 'loading', false);
                    });
                }).catch(() => {});
            }
        }
    }
</script>

<style scoped>

</style>
